import { Garage } from '@/types/garage'
import { Image, Box, Flex, Heading, Link } from '@chakra-ui/react'
import NextLink from 'next/link'
import { UserAvatar } from './UserAvatar'
import { getPrefixedStorageURL } from '@/lib/getPrefixedStorageURL'

export const GarageProfileMicro = (props: {
  garage: Garage
}): JSX.Element | null => {
  if (!props.garage.public) return null
  const { garage } = props
  return (
    <NextLink href={`/nation/garages/${garage.slug}`} passHref legacyBehavior>
      <Link>
        <Flex alignItems='center'>
          {garage.logo ? (
            <div>
              <Image
                src={`${getPrefixedStorageURL(
                  garage.logo,
                  'imgkit'
                )}?tr:h-96,cm-pad_resize')`}
                alt={garage.title}
                width={120}
                height={56}
                style={{
                  objectFit: 'contain',
                  height: '56px',
                }}
                objectPosition={{ base: 'center', md: 'left' }}
              />
            </div>
          ) : (
            <>
              {props.garage.user && <UserAvatar user={props.garage.user} />}
              <Heading as='h2' fontSize='md' ml={2}>
                <Box fontSize='lg' mb='.5'>
                  {garage.title}
                </Box>
                <Box
                  fontSize='xs'
                  fontWeight='normal'
                  textTransform='uppercase'>
                  {garage.city ? `${garage.city}, ` : null}
                  {garage.state ? `${garage.state}, ` : null}
                  {garage.country}
                </Box>
              </Heading>
            </>
          )}
        </Flex>
      </Link>
    </NextLink>
  )
}
